<template>
  <v-layout row wrap>
    <v-flex xs12 sm12>
      <v-toolbar flat color="white">
        <v-tooltip bottom>
          <v-btn
            icon
            light
            @click="$router.push({ name: 'inbox' })"
            slot="activator"
          >
            <v-icon color="grey darken-2">arrow_back</v-icon>
          </v-btn>
          <span>{{ $vuetify.t('$vuetify.app.back') }}</span>
        </v-tooltip>
        <v-toolbar-title
          >{{ $vuetify.t('$vuetify.calls.inbox') }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card>
        <v-card-title primary-title color="blue-grey darken-2">
          <span class="title">{{ messageDetail.subject }}</span>
        </v-card-title>
        <v-card-text>
          {{ messageDetail.message }}
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Message',
  mixins: [],
  components: {},
  data() {
    return {
      result: []
    }
  },
  mounted() {
    const item = this.getMessageById(this.$route.params.id)
    this.markAsRead({
      item: item,
      read_at: moment().format('YYYY-MM-DD HH:mm:ss')
    })
      .then(r => {
        return r
      })
      .then(r => {
        // Update in offline DB??
      })
  },
  computed: {
    ...mapGetters({
      getMessageById: 'messaging/getMessageById'
    }),
    messageDetail() {
      return this.getMessageById(this.$route.params.id)
    }
  },
  methods: {
    ...mapActions({
      markAsRead: 'messaging/markAsRead'
    })
  }
}
</script>
